import React, {useCallback} from 'react';
import TenantGrid from './TenantGrid';

const AdminTenants = ({route, navigation}) => {
  const openTenant = useCallback(
    row =>
      navigation.navigate('AdminTenantPage', {
        tenantId: row.id,
        tenantName: row.name
      }),
    [navigation]
  );
  return (
    <TenantGrid
      onOpenMenu={() => route?.params?.openMenuDrawer?.()}
      onOpenTenant={openTenant}
    />
  );
};

export default AdminTenants;
